import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionAuthentication from "./component";
import { withRouter } from "react-router-dom";
import { updateProfile, saveUserConsent } from "../../configuration/actions";
import { fetchInspectionDetailsViaLeadToken, fetchInspectionDetails, fetchLoginDetailsViaLeadToken, fetchLoginDetails } from "../post-inspection-diy/actions";
import { checkLeadPhoneNumber, sendOtpViaLeadToken, verifyOtpViaLeadToken } from "../../mobile/reg-number-details-wrapper/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse
    },
    user: { mobile, secureToken },
    repeatUserTransition: {
        pageLoading,
        loaderTitle
    }
}) => ({
    secureToken,
    inspectionResponse,
    mobile,
    pageLoading,
    loaderTitle
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateProfileConnect: updateProfile,
    saveUserConsentConnect: saveUserConsent,
    fetchInspectionDetailsViaLeadTokenConnect: fetchInspectionDetailsViaLeadToken,
    fetchInspectionDetailsConnect: fetchInspectionDetails,
    sendOtpViaLeadTokenConnect: sendOtpViaLeadToken,
    verifyOtpViaLeadTokenConnect: verifyOtpViaLeadToken,
    checkLeadPhoneNumberConnect: checkLeadPhoneNumber,
    fetchLoginDetailsViaLeadTokenConnect: fetchLoginDetailsViaLeadToken,
    fetchLoginDetailsConnect: fetchLoginDetails
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionAuthentication));
